import { StorageWrapper } from "../services/StorageWrapper";
import { LocalStorageKeys } from "../models/StorageKeys";

export function loadFromStorage(storageWrapper: StorageWrapper, key: LocalStorageKeys): any {
    const raw = storageWrapper.loadLocalStorage(key);
    if (!raw || raw === "") return undefined;
    try {
        return JSON.parse(raw);
    } catch {
        return undefined;
    }
}

export function saveToStorage(storageWrapper: StorageWrapper, key: LocalStorageKeys, value: any): void {
    if (value === undefined) return;
    storageWrapper.saveLocalStorage(key, JSON.stringify(value));
}

export function removeFromStorage(storageWrapper: StorageWrapper, key: LocalStorageKeys): void {
    storageWrapper.removeLocalStorageItem(key);
}
